<template>
  <div class="tin-page">
    <div class="ambient"></div>
    <div class="grain"></div>
    <div class="frame"></div>
    <div class="frame-inner"></div>

    <div class="page-inner">
      <div class="wm-row slim">
        <div class="wm-line"></div>
        <span class="wm-text">The Inner Network · Admin</span>
        <div class="wm-line r"></div>
      </div>
      <h1 class="page-title left">Member <em>Directory</em></h1>

      <div class="search-box">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input v-model="searchText" class="search-input" type="text" placeholder="Search by name or title…" @input="filterMembers" />
      </div>

      <div v-if="isLoading" class="empty-block">
        <div class="seal small"><div class="seal-ring"></div><div class="seal-ring-dashed"></div><div class="seal-diamond"></div></div>
        <p class="empty-text">Loading members…</p>
      </div>

      <div v-else-if="!filteredMembers.length" class="empty-block">
        <div class="empty-diamond"></div>
        <p class="empty-title">No results</p>
        <p class="empty-text">No members match your search.</p>
      </div>

      <div v-else class="member-list">
        <button v-for="user in filteredMembers" :key="user.id" class="member-row" @click="viewUserDetails(user)">
          <div class="member-avatar">
            <img v-if="user.image" :src="user.image" alt="" />
            <span v-else>{{ initials(user.fullName) }}</span>
          </div>
          <div class="member-info">
            <p class="member-name">{{ user.fullName || "Unnamed" }}</p>
            <p class="member-title">{{ (user.title || user.type || "Member").toUpperCase() }}</p>
          </div>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    </div>

    <!-- Bottom Tab Bar -->
    <div class="admin-tab-bar">
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminHomeView' }" @click="$router.push({ name: 'AdminHomeView' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        <span>Home</span>
      </button>
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminSearch' }" @click="$router.push({ name: 'AdminSearch' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <span>Search</span>
      </button>
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminWaitlist' }" @click="$router.push({ name: 'AdminWaitlist' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        <span>Waitlist</span>
      </button>
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminFlags' }" @click="$router.push({ name: 'AdminFlags' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>
        <span>Flags</span>
      </button>
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminMessages' }" @click="$router.push({ name: 'AdminMessages' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
        <span>Messages</span>
      </button>
      <button class="tab-item" :class="{ 'tab-item--active': $route.name === 'AdminSettings' }" @click="$router.push({ name: 'AdminSettings' })">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
        <span>Settings</span>
      </button>
    </div>
  </div>
</template>

<script>
import { collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase";

// Complete rewrite. The previous version was old Vuetify (blue app bar,
// mdi- icons, generic card grid) and had the same bottom nav routing to
// "/minister-prayer-requests" seen in the other admin pages - a leftover
// from a different app template, not this one. This is a member directory
// search, so it now reuses the same list-row pattern (avatar/name/title)
// as the rest of the app instead of a Vuetify card grid.
export default {
  name: "AdminSearchView",
  data() {
    return {
      searchText: "",
      members: [],
      filteredMembers: [],
      isLoading: true,
    };
  },
  methods: {
    async fetchMembers() {
      this.isLoading = true;
      try {
        const snapshot = await getDocs(collection(db, "user"));
        this.members = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => (a.fullName || "").localeCompare(b.fullName || ""));
        this.filterMembers();
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        this.isLoading = false;
      }
    },
    filterMembers() {
      const q = this.searchText.toLowerCase();
      this.filteredMembers = this.members.filter(
        (member) =>
          (member.fullName && member.fullName.toLowerCase().includes(q)) ||
          (member.title && member.title.toLowerCase().includes(q))
      );
    },
    initials(name) {
      const n = (name || "").trim();
      if (!n) return "?";
      return n.split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase() || "").join("");
    },
    viewUserDetails(user) {
      this.$router.push({ name: "MemberDetail", params: { id: user.id } });
    },
  },
  async mounted() {
    await this.fetchMembers();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,400;1,300;1,400&family=Montserrat:wght@300;400;500;600&display=swap');
.tin-page { position: relative; min-height: 100vh; background: #070708; }
.ambient { position: fixed; top: -300px; left: 50%; transform: translateX(-50%); width: 1000px; height: 800px; pointer-events: none; z-index: 0; background: radial-gradient(ellipse at 50% 10%, rgba(210,175,100,0.1) 0%, rgba(210,175,100,0.03) 30%, transparent 65%); }
.grain { position: fixed; inset: 0; z-index: 1; pointer-events: none; opacity: 0.5; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.12'/%3E%3C/svg%3E"); background-size: 180px 180px; }
.frame { position: fixed; inset: 28px; border: 1px solid rgba(210,175,100,0.08); z-index: 2; pointer-events: none; }
.frame::before, .frame::after { content: ''; position: absolute; width: 20px; height: 20px; }
.frame::before { top: -1px; left: -1px; border-top: 1px solid rgba(210,175,100,0.5); border-left: 1px solid rgba(210,175,100,0.5); }
.frame::after { bottom: -1px; right: -1px; border-bottom: 1px solid rgba(210,175,100,0.5); border-right: 1px solid rgba(210,175,100,0.5); }
.frame-inner { position: fixed; inset: 28px; z-index: 2; pointer-events: none; }
.frame-inner::before, .frame-inner::after { content: ''; position: absolute; width: 20px; height: 20px; }
.frame-inner::before { top: -1px; right: -1px; border-top: 1px solid rgba(210,175,100,0.5); border-right: 1px solid rgba(210,175,100,0.5); }
.frame-inner::after { bottom: -1px; left: -1px; border-bottom: 1px solid rgba(210,175,100,0.5); border-left: 1px solid rgba(210,175,100,0.5); }
.page-inner { position: relative; z-index: 10; max-width: 680px; margin: 0 auto; padding: 60px 40px 100px; }
.wm-row { display: flex; align-items: center; gap: 14px; }
.wm-row.slim { margin-bottom: 20px; }
.wm-line { flex: 1; height: 1px; background: linear-gradient(90deg, transparent, rgba(210,175,100,0.2)); }
.wm-line.r { background: linear-gradient(90deg, rgba(210,175,100,0.2), transparent); }
.wm-text { font-family: 'Montserrat', sans-serif; font-size: 11px; font-weight: 600; letter-spacing: 4px; color: rgba(210,175,100,0.5); text-transform: uppercase; }
.page-title { font-family: 'Cormorant', serif; font-size: 34px; font-weight: 300; color: #edeae2; margin-bottom: 24px; }
.page-title.left { text-align: left; }
.page-title em { font-style: italic; color: rgba(210,175,100,0.8); }

.search-box { display: flex; align-items: center; gap: 10px; border-bottom: 1px solid rgba(237,232,223,0.1); padding: 12px 4px; margin-bottom: 24px; color: rgba(210,175,100,0.4); }
.search-input { flex: 1; background: none; border: none; outline: none; font-family: 'Montserrat', sans-serif; font-size: 14px; font-weight: 300; color: #edeae2; }
.search-input::placeholder { color: rgba(237,232,223,0.2); font-style: italic; }

.empty-block { display: flex; flex-direction: column; align-items: center; padding: 60px 0; }
.empty-diamond { width: 14px; height: 14px; border: 1px solid rgba(210,175,100,0.5); transform: rotate(45deg); margin-bottom: 20px; }
.empty-title { font-family: 'Cormorant', serif; font-style: italic; font-size: 20px; color: rgba(237,232,223,0.3); margin-bottom: 6px; }
.empty-text { font-family: 'Montserrat', sans-serif; font-size: 12px; color: rgba(237,232,223,0.2); }
.seal { position: relative; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; margin-bottom: 16px; }
.seal-ring { position: absolute; inset: 0; border-radius: 50%; border: 1px solid rgba(210,175,100,0.2); animation: spinSlow 40s linear infinite; }
.seal-ring-dashed { position: absolute; inset: 4px; border-radius: 50%; border: 1px dashed rgba(210,175,100,0.15); animation: spinSlow 25s linear infinite reverse; }
@keyframes spinSlow { to { transform: rotate(360deg); } }
.seal-diamond { width: 10px; height: 10px; border: 1px solid rgba(210,175,100,0.7); transform: rotate(45deg); position: relative; z-index: 1; }
.seal-diamond::after { content: ''; position: absolute; inset: 2px; background: rgba(210,175,100,0.35); }

.member-list { display: flex; flex-direction: column; gap: 8px; }
.member-row { display: flex; align-items: center; gap: 14px; background: rgba(210,175,100,0.03); border: 1px solid rgba(210,175,100,0.1); padding: 14px; cursor: pointer; text-align: left; color: rgba(210,175,100,0.3); }
.member-avatar { width: 44px; height: 44px; border-radius: 50%; border: 1px solid rgba(210,175,100,0.25); display: flex; align-items: center; justify-content: center; overflow: hidden; flex-shrink: 0; font-family: 'Cormorant', serif; font-size: 15px; color: rgba(210,175,100,0.5); }
.member-avatar img { width: 100%; height: 100%; object-fit: cover; }
.member-info { flex: 1; min-width: 0; }
.member-name { font-family: 'Cormorant', serif; font-size: 16px; color: #edeae2; }
.member-title { font-family: 'Montserrat', sans-serif; font-size: 8px; font-weight: 600; letter-spacing: 1.5px; color: rgba(210,175,100,0.4); margin-top: 2px; }

/* ── ADMIN TAB BAR ── */
.admin-tab-bar { position: fixed; bottom: 0; left: 0; right: 0; z-index: 50; display: flex; background: rgba(7,7,8,0.97); border-top: 1px solid rgba(210,175,100,0.12); padding: 10px 0 max(10px, env(safe-area-inset-bottom)); }
.tab-item { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 5px; background: none; border: none; cursor: pointer; color: rgba(237,232,223,0.25); padding: 6px 0; }
.tab-item span { font-family: 'Montserrat', sans-serif; font-size: 9px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; }
.tab-item--active { color: rgba(210,175,100,0.85); }
</style>